import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { DeviationResourceType } from '../../../types/deviation';
const DeleteTier = ({ deviation, deleteTier })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(ListItem, {
        label: t('common.delete'),
        onClick: deleteTier,
        biData: {
            evid: BiEventType.TIER_DELETE,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId
        }
    });
};
DeleteTier.displayName = 'DeleteTier';
export default DeleteTier;
